import { render, staticRenderFns } from "./NewReturnsModal.vue?vue&type=template&id=d6a570be&"
import script from "./NewReturnsModal.vue?vue&type=script&lang=js&"
export * from "./NewReturnsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "NewReturnsModal.vue"
export default component.exports